// 判断是否为JSON格式的数据
export const isJSON = str => {
  try {
    let obj = str;
    if (typeof str === "string") obj = JSON.parse(str);
    if (typeof obj === "object" && obj) {
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

// path: 'key1.key2[num1][num2]'
export function getValueByKey(jsonData, path) {
  let result = jsonData;
  if (!isJSON(jsonData)) return "";
  let keys = path.split(".");
  keys = keys
    .map(key => {
      const option = key.split("[").map(d => {
        if (d.includes("]")) {
          return parseInt(d);
        }
        return d;
      });
      return option;
    })
    .flat();
  const keysLength = keys.length;
  for (const i in keys) {
    const value = result[keys[i]];
    if (i < keysLength - 1 && !isJSON(value)) return "";
    result = value;
  }
  return result;
}

// 数组去重
export const duplicateRemove = (list = [], { key = "id" }) => {
  const keys = [];
  const result = [];
  list.forEach(d => {
    const dKey = d[key];
    if (!keys.includes(dKey)) {
      keys.push(dKey);
      result.push(d);
    }
  });
  return result;
};

export function total(list = [], key = "", param = {}) {
  const { render } = param;
  let totalNum = 0;
  list.forEach(d => {
    const num = Number(getValueByKey(d, key)) || 0;
    if (render) totalNum += render(num, d);
    else totalNum += num;
  });
  return totalNum;
}

export const amount = (list, amountKeys) => {
  const countResults = amountKeys.reduce((pre, cur) => {
    pre[cur] = 0;
    return pre;
  }, {});
  list.forEach(item => {
    // 统计
    for (let key in countResults) {
      countResults[key] = countResults[key].add(parseFloat(item[key] || 0));
    }
  });
  return countResults;
};

export function getUrlFromFileList(fileList, option = {}) {
  const { fileNum = 1, key = "attachUrl" } = option;
  const list = fileList.filter(d => d.status === "done");
  const fileMes = list.map(d => {
    const resultMessageStr = getValueByKey(d, "response.resultMessage");
    const resultMessage =
      d.resultMessage || (resultMessageStr && JSON.parse(resultMessageStr))[0];
    if (key) return resultMessage[key];
    return resultMessage;
  });
  if (fileNum === 1) return fileMes[0];
  return fileMes;
}

// 字典值获取value
export function getDicValueByCode(
  code,
  list,
  keyName = "dicKey",
  valueName = "dicValue"
) {
  for (let i = 0; i < list.length; i++) {
    const d = list[i];
    if (d[keyName] == code) {
      return d[valueName];
    }
  }
  return "";
}

// 数字转换为每3位一个逗号隔开,只用于展示数据
export function thousands(num, type = "amount", digit = 2) {
  if (!num) {
    if(num !== 0) return ''
    return "0";
  }
  let str = num;
  str = Number(num).toFixed(digit);
  if (str === "0.00") {
    str = "0";
  }
  // 折扣为1不能带小数点
  if (str === "1.00" && type === "discount") {
    str = "1";
  }
  const reg =
    str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  return str.replace(reg, "$1,");
}



// WEBPACK FOOTER //
// ./src/public/utils/utils.js